import { ModosOp} from "../../isp._comun/iu/_principal/constantesIuPrin";
import { TipoPlan, UnidAnchoBanda, Moneda, Udm } from "../../isp.žapi.planes/constantesApiPlanes";

//Si no hay input para el Dialogo de Cliente a Facturar
const getEstadoInicial = () => {
    return {
        domain: {
            screen:{
                idPlan: "-------",
                fechaReg: "--/--/--",
                estado: "-------",

                nombre: "",
                descripcion: "",
                precio: "",
                moneda: Moneda.Soles,
                udm: Udm.Mensual,
                anchoBanda: "",
                unidAnchoBanda: UnidAnchoBanda.Megas,
                combos:{
                    // udms:[Udm.Mensual],
                    // tipoAnchoBanda:[TipoPlan.PlanInternet,TipoPlan.ServiciosGen, TipoPlan.Articulo]
                }
            },
            cargado: {}, //Data de una entidad cargada en el dialogo desde la Base de Datos
            update: {}, //Solo tiene data temporal del dominio va a modificar una entidad
            nroUpdates: 0,
        },
        error: {
            nomBlanc: false,
            nomMF: false,
            descripMF: false,
            precioBlanc: false,
            // precioMF: false,
            anchoBandBlanc: false,
            /* rsocialBlanc: false,
            rsocialMF: false,
            rucBlanc: false,
            rucMF: false,
            telcel1Blanc: false,
            telcel1MF: false,
            telcel2MF: false,
            telfijoMF: false,
            emailMF: false,
            sitioWebMF: false, */
        },
        flag: {
            modoOperacion: ModosOp.CREAR,
            procesandoComando: false,
            modal: false,
            cargandoEntidad: false,
            sensorForceUpdate:false
            // iniciando: true
            // sensorDeAccionGuardar: false,
            // sensorDeAccionActualizar: false,
        },
    };
};

export default getEstadoInicial;
